// Combined floor plan data for 37 Kimbark Boulevard.
// Polygons: normalized [x,y] coords (0–1) traced from the original PDF floor plan.
//   They map onto the SVG images at /floor-plans/floor{1,2,3}.svg via x*1800, y*1350.
// Teleport coords: Three.js world space calibrated 2026-08-17 from SI sessions.
//   World X = SI East, World Y = SI Up, World Z = −SI North + 1.887.
// Rooms without viewpointWorld are shown but not clickable (original layout changed).

export type KimbarkFloor = 'basement' | 'ground' | 'upper';

export interface KimbarkRoom {
  name: string;
  floor: KimbarkFloor;
  /** Normalized polygon vertices [x, y] ∈ [0,1] from the traced floor plan. */
  poly: [number, number][];
  /** Real-world dimensions [width, depth] in metres, where available. */
  dims?: [number, number];
  /** Camera landing position in Three.js world space. Undefined = no teleport. */
  viewpointWorld?: [number, number, number];
  /** Camera lookAt target in Three.js world space. */
  objectWorld?: [number, number, number];
}

export const KIMBARK_ROOMS: KimbarkRoom[] = [
  // ── BASEMENT (Floor 1 in original plan) ─────────────────────────────────────
  {
    name: 'Room',
    floor: 'basement',
    dims: [2.65, 2.5],
    poly: [[0.195,0.0667],[0.195,0.2163],[0.3221,0.2178],[0.3205,0.104],[0.31,0.1007],[0.31,0.0653]],
    viewpointWorld: [0.742, -2.464, 4.855],
    objectWorld:    [-4.732, -2.621, -0.977],
  },
  {
    name: 'Sauna',
    floor: 'basement',
    poly: [[0.195,0.2253],[0.195,0.2627],[0.1938,0.3205],[0.3205,0.319],[0.32,0.2194],[0.27,0.2189],[0.2695,0.2247]],
    viewpointWorld: [-1.533, -2.491, 5.599],
    objectWorld:    [4.583, -3.359, 10.683],
  },
  {
    name: 'Room',
    floor: 'basement',
    dims: [6.97, 4.48],
    poly: [[0.33,0.0347],[0.33,0.1007],[0.322,0.104],[0.322,0.2767],[0.33,0.28],[0.33,0.3193],[0.3905,0.3193],[0.3937,0.33],[0.4395,0.33],[0.4427,0.3193],[0.6633,0.3193],[0.6635,0.2147],[0.7057,0.2127],[0.7057,0.104],[0.654,0.104],[0.4848,0.104],[0.4815,0.0343]],
    viewpointWorld: [-0.866, -2.286, 4.151],
    objectWorld:    [-7.483, -4.342, 8.158],
  },
  {
    name: 'Laundry',
    floor: 'basement',
    dims: [2.65, 2.42],
    poly: [[0.2043,0.4386],[0.2042,0.4847],[0.3288,0.4852],[0.3281,0.3447],[0.2315,0.3447],[0.2311,0.3947],[0.1943,0.3943],[0.1936,0.4365]],
    viewpointWorld: [0.184, -2.742, 3.639],
    objectWorld:    [7.638, -2.990, 6.554],
  },
  {
    name: 'Hall',
    floor: 'basement',
    dims: [3.08, 2.42],
    poly: [[0.33,0.332],[0.33,0.4163],[0.3972,0.4183],[0.3977,0.4869],[0.476,0.4847],[0.476,0.3953],[0.4765,0.3413],[0.4758,0.3317]],
  },
  {
    name: 'Utility',
    floor: 'basement',
    dims: [4.67, 2.42],
    poly: [[0.4828,0.333],[0.4828,0.4847],[0.5765,0.4859],[0.636,0.4843],[0.7057,0.4847],[0.7057,0.423],[0.6813,0.4197],[0.6827,0.3937],[0.7057,0.3923],[0.7057,0.3317]],
    viewpointWorld: [0.184, -2.742, 3.639],
    objectWorld:    [7.638, -2.990, 6.554],
  },

  // ── GROUND FLOOR (Floor 2 in original plan) ──────────────────────────────────
  {
    name: 'Breakfast Nook',
    floor: 'ground',
    dims: [3.69, 4.45],
    poly: [[0.324,0.036],[0.325,0.0913],[0.306,0.096],[0.306,0.2037],[0.3046,0.3523],[0.497,0.3523],[0.497,0.096],[0.4968,0.085],[0.4963,0.0363],[0.4537,0.036],[0.3593,0.0357]],
    viewpointWorld: [-2.223, -0.655, 5.546],
    objectWorld:    [3.334, -0.062, -0.178],
  },
  {
    name: 'Kitchen',
    floor: 'ground',
    dims: [2.8, 4.45],
    poly: [[0.1542,0.0366],[0.1545,0.1977],[0.1545,0.331],[0.203,0.3317],[0.205,0.3523],[0.3044,0.3511],[0.3035,0.2007],[0.3035,0.0943],[0.2934,0.0922],[0.2925,0.0363]],
    viewpointWorld: [-1.452, 0.266, 3.583],
    objectWorld:    [5.279, 0.085, 7.023],
  },
  {
    name: 'Living Room',
    floor: 'ground',
    dims: [3.67, 5.85],
    poly: [[0.5045,0.0953],[0.5045,0.5133],[0.6767,0.5133],[0.7003,0.513],[0.7005,0.3693],[0.7153,0.3413],[0.7,0.3473],[0.6997,0.255],[0.7408,0.2453],[0.7408,0.126],[0.7325,0.1167],[0.7023,0.1163],[0.7003,0.0953],[0.6695,0.095]],
    viewpointWorld: [-3.065, 0.120, 0.834],
    objectWorld:    [-5.089, -0.834, 8.514],
  },
  {
    name: 'Hall',
    floor: 'ground',
    poly: [[0.2865,0.3637],[0.2871,0.4399],[0.3493,0.4397],[0.346,0.4467],[0.3473,0.5133],[0.497,0.5127],[0.497,0.4863],[0.497,0.3863],[0.4968,0.3627],[0.4457,0.3623],[0.3665,0.3623]],
    viewpointWorld: [-4.530, 0.091, 3.935],
    objectWorld:    [1.156, -0.211, -1.685],
  },
  {
    name: 'Foyer',
    floor: 'ground',
    poly: [[0.415,0.637],[0.4155,0.654],[0.4602,0.6537],[0.5158,0.654],[0.5765,0.654],[0.5765,0.547],[0.527,0.547],[0.5238,0.5393],[0.4909,0.5399],[0.4894,0.5187],[0.4328,0.5183],[0.4328,0.5387],[0.4155,0.5393],[0.415,0.5497]],
    viewpointWorld: [-0.050, 0.100, 3.183],
    objectWorld:    [-0.050, 0.100, -4.817],
  },
  {
    name: 'Dining Area',
    floor: 'ground',
    dims: [4.28, 4.11],
    poly: [[0.584,0.547],[0.5857,0.6817],[0.584,0.7187],[0.5835,0.8],[0.584,0.8157],[0.8125,0.8157],[0.814,0.7503],[0.813,0.615],[0.8125,0.527],[0.7625,0.527],[0.758,0.5467],[0.678,0.5467],[0.6735,0.527],[0.5982,0.527],[0.5968,0.545]],
    viewpointWorld: [-2.542, 0.159, -1.066],
    objectWorld:    [-8.111, -1.607, -6.531],
  },
  {
    name: 'Bathroom',
    floor: 'ground',
    poly: [[0.1523,0.3611],[0.1912,0.362],[0.1924,0.4648],[0.1517,0.4632]],
    viewpointWorld: [0.533, -0.501, 5.333],
    objectWorld:    [6.090, 0.092, -0.391],
  },

  // ── UPPER FLOOR (Floor 3 in original plan) ───────────────────────────────────
  {
    name: 'Bedroom',
    floor: 'upper',
    poly: [[0.3685,0.0343],[0.3683,0.2557],[0.4808,0.2557],[0.4795,0.2032],[0.5256,0.2028],[0.5232,0.153],[0.5232,0.0343],[0.4565,0.0343],[0.4012,0.0343]],
    viewpointWorld: [-0.433, 2.594, 4.967],
    objectWorld:    [-3.370, 2.023, 12.386],
  },
  {
    name: 'Bedroom',
    floor: 'upper',
    poly: [[0.1973,0.0343],[0.1973,0.2683],[0.265,0.2687],[0.2682,0.2557],[0.3615,0.2557],[0.3615,0.0343],[0.3028,0.0347],[0.2415,0.0347]],
    viewpointWorld: [2.328, 2.627, 5.321],
    objectWorld:    [0.264, 2.161, 13.036],
  },
  {
    name: 'Sitting Room',
    floor: 'upper',
    dims: [3.79, 4.6],
    poly: [[0.53,0.0343],[0.53,0.3243],[0.5978,0.3243],[0.7087,0.3243],[0.7087,0.0347]],
    viewpointWorld: [-1.819, 2.730, 3.210],
    objectWorld:    [-7.782, 2.795, 8.542],
  },
  {
    name: 'Hall',
    floor: 'upper',
    dims: [5.31, 1.68],
    poly: [[0.2717,0.437],[0.4073,0.4307],[0.4078,0.3263],[0.5232,0.3243],[0.528,0.3153],[0.5282,0.2654],[0.4108,0.2647],[0.37,0.2643],[0.3435,0.266],[0.3315,0.2643],[0.292,0.2643],[0.2717,0.2647]],
    // Upper landing — no specific teleport
  },
  {
    name: 'Hall',
    floor: 'upper',
    poly: [[0.5962,0.3333],[0.5962,0.4373],[0.7087,0.4367],[0.7085,0.3493],[0.6883,0.3483],[0.6867,0.3333]],
  },
  {
    name: 'Bath',
    floor: 'upper',
    dims: [3.72, 1.68],
    poly: [[0.4607,0.3333],[0.4612,0.4373],[0.5895,0.4373],[0.5895,0.3333],[0.501,0.3333],[0.498,0.336],[0.4948,0.3333]],
    viewpointWorld: [-2.823, 2.593, 0.256],
    objectWorld:    [-1.874, 1.565, 8.132],
  },
  {
    name: 'W.I.C.',
    floor: 'upper',
    dims: [2.35, 1.98],
    poly: [[0.6927,0.4463],[0.6927,0.5697],[0.8033,0.5703],[0.8025,0.4463]],
    viewpointWorld: [-1.773, 2.718, -1.882],
    objectWorld:    [-8.142, 2.029, 2.990],
  },
  {
    name: 'Primary Bedroom',
    floor: 'upper',
    dims: [4.37, 5.94],
    poly: [[0.5962,0.4463],[0.5982,0.7007],[0.5962,0.734],[0.5958,0.8117],[0.5962,0.8207],[0.8025,0.8207],[0.8025,0.5787],[0.6873,0.578],[0.6857,0.488],[0.6857,0.4463]],
    viewpointWorld: [-0.679, 2.862, -3.866],
    objectWorld:    [-8.373, 2.957, -6.058],
  },
  {
    name: 'Bath',
    floor: 'upper',
    poly: [[0.1973,0.2777],[0.1975,0.4376],[0.2647,0.437],[0.265,0.278]],
    viewpointWorld: [2.329, 2.649, 4.889],
    objectWorld:    [9.445, 1.773, 8.439],
  },
];

export const FLOOR_SVG: Record<KimbarkFloor, string> = {
  basement: '/floor-plans/floor1.svg',
  ground:   '/floor-plans/floor2.svg',
  upper:    '/floor-plans/floor3.svg',
};

export const FLOOR_LABEL: Record<KimbarkFloor, string> = {
  basement: 'Basement',
  ground:   'Ground Floor',
  upper:    'Upper Floor',
};
